"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RateLimitAddEventText = exports.RateLimitGenericText = exports.rateLimitCode = exports.extractCalendarInstanceDateTimeId = exports.extractCalendarEventId = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var extractCalendarEventId = function extractCalendarEventId(id) {
  var index = id.indexOf('_');

  if (index > 0) {
    return id.slice(0, index);
  }

  return id;
};

exports.extractCalendarEventId = extractCalendarEventId;

var extractCalendarInstanceDateTimeId = function extractCalendarInstanceDateTimeId(instanceId) {
  var index = instanceId.indexOf('_');

  if (index > 0) {
    return instanceId.slice(index + 1);
  }
};

exports.extractCalendarInstanceDateTimeId = extractCalendarInstanceDateTimeId;
var rateLimitCode = 403;
exports.rateLimitCode = rateLimitCode;

var RateLimitGenericText = _i18next["default"].t('calendar.event.error.rate.limit.generic');

exports.RateLimitGenericText = RateLimitGenericText;

var RateLimitAddEventText = _i18next["default"].t('calendar.event.error.rate.limit.add');

exports.RateLimitAddEventText = RateLimitAddEventText;
//# sourceMappingURL=calendar.js.map